// extracted by mini-css-extract-plugin
export default {"container":"root_modal-content-layout-module__container___t7TJs"};